module.exports = __webpack_public_path__ + "img/the-black-gods-drums.f24ef010.png";